function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useRef } from 'react';
import { useCombineCallback, useCombineRef, useRefCallback } from '@bydesign-ui/hooks';
import { pascalCase } from '@bydesign-ui/utils';
import { getRelativeKeys, useFormField, useFormScope, useWatchField } from '../../hooks/form';
export function withField(Component, initialValue, options) {
  var _ref = options || {},
      displayName = _ref.displayName,
      _ref$useDomRef = _ref.useDomRef,
      useDomRef = _ref$useDomRef === void 0 ? false : _ref$useDomRef,
      _ref$useInputRef = _ref.useInputRef,
      useInputRef = _ref$useInputRef === void 0 ? false : _ref$useInputRef,
      _ref$useInvalid = _ref.useInvalid,
      useInvalid = _ref$useInvalid === void 0 ? false : _ref$useInvalid;

  function FieldComponent(props) {
    var field = props.field,
        defaultValue = props.defaultValue,
        rules = props.rules,
        label = props.label,
        propsDomRef = props.domRef,
        propsInputRef = props.inputRef,
        propsOnBlur = props.onBlur,
        onFieldChange = props.onFieldChange,
        extra = _objectWithoutProperties(props, ["field", "defaultValue", "rules", "label", "domRef", "inputRef", "onBlur", "onFieldChange"]);

    var _useFormField = useFormField({
      label: label,
      field: field,
      defaultValue: defaultValue,
      rules: rules,
      initialValue: initialValue
    }),
        value = _useFormField.value,
        onValueChange = _useFormField.onValueChange,
        fieldDomRef = _useFormField.domRef,
        fieldInputRef = _useFormField.inputRef,
        fieldOnBlur = _useFormField.onBlur,
        valid = _useFormField.valid;

    var ready = useRef(false);
    var onBlur = useCombineCallback(propsOnBlur, fieldOnBlur);
    var domRef = useCombineRef(propsDomRef, fieldDomRef);
    var inputRef = useCombineRef(propsInputRef, fieldInputRef);
    var onFieldChangeCallback = useRefCallback(onFieldChange);
    var scope = useFormScope();
    var fieldKey = getRelativeKeys(scope).concat(field).join('.');
    var fieldValue = useWatchField(fieldKey);
    useEffect(function () {
      ready.current && onFieldChangeCallback(fieldValue);
    }, [fieldValue]);
    useEffect(function () {
      ready.current = true;
    }, []);

    var p = _objectSpread(_objectSpread({}, extra), {}, {
      value: value,
      onValueChange: onValueChange,
      onBlur: onBlur
    });

    if (useDomRef) {
      p.domRef = domRef;
    }

    if (useInputRef) {
      p.inputRef = inputRef;
    }

    if (useInvalid) {
      p.invalid = !valid;
    }

    return React.createElement(Component, p);
  }

  if (displayName) {
    FieldComponent.displayName = displayName;
  } else if (Component.displayName) {
    FieldComponent.displayName = 'Field' + pascalCase(Component.displayName);
  } else {
    FieldComponent.displayName = 'Field';
  }

  return FieldComponent;
}